import src from "IMAGE";
export default { src, width: 4095, height: 918, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR42jXK7QmAERiF4ed9yxqi5GsAZQ3ZhTHYwEJmsIpD+XF16nRTCXNl3cf/MUlEHAw4sFeNcyXVTqBwCDjrnw2a5gnd6jpiowAAAABJRU5ErkJggg=="};
